module.exports = "img/voip-mute.460ba6a.png";